<template>
  <div>
    <el-input v-if="!params.isNumber" ref="input" v-model="value" :filter-chars="filterChart" :data-code="params.field || ''" v-bind="params.inputProps" @blur="onBlur" />
    <el-input v-if="params.isNumber" ref="input" v-model="value" v-stopNumberMousewheel type="number" style="width: 100%" v-bind="params.inputProps" @blur="onBlur" />
  </div>
</template>

<script>
import Vue from 'vue'
import TableKeyboardNav from '@/mixin/TableKeyboardNav'
export default Vue.extend({
  name: 'CargoAgGridCommonInputEditor',
  mixins: [TableKeyboardNav],
  data() {
    return {
      value: '',
      type: 'input',
      filterChart: true
    }
  },
  created() {
    console.log('oninputeditor')
    this.value = this.params.value
    if (this.params?.filterChart === false) {
      this.filterChart = false
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.input) {
        this.$refs.input.focus()
        this.$refs.input.select()
      }
    })
  },
  methods: {
    getValue() {
      if (this.params.isNumber) {
        const { precision } = this.params.inputProps ? this.params.inputProps : 0
        if (this.params.distinguishNullAndZero && (this.value === null || this.value === undefined || this.value === '')) {
          return ''
        }
        if (precision) {
          let formatStr = '0.'
          for (let i = 0; i < precision; i++) {
            formatStr += '0'
          }
          return this.$numeral(this.value).format(formatStr)
        }
        if (precision === 0) {
          return this.$numeral(this.value).format('0')
        }
      }
      if (typeof this.value === 'string') {
        if (this.params.isUppercase) {
          this.value = this.value.toUpperCase()
        }
        if (this.params.isTrim) {
          this.value = this.value.trim()
        }
      }
      return this.value
    },
    onBlur() {
      console.log('input-stop',)
      this.params.api.stopEditing()
    }
  }
})
</script>
